import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {CompaniesRoutingModule} from './companies-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {CompaniesComponent} from './companies.component';
import {CompaniesRepository} from './repositories/companies.repository';
import {CompaniesService} from './services/companies.service';

@NgModule({
  imports: [
    CommonModule,
    CompaniesRoutingModule,
    SearchBarModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    FormsModule,
    ModalConfirmationModule,
  ],
  declarations: [
    CompaniesComponent,
  ],
  providers: [
    CompaniesService,
    CompaniesRepository,
  ],
})

export class CompaniesModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/companies/companies.module.ts